import { graphql } from "../../generated";

export const productCategoriesQuery = graphql(/* GraphQL */ `
    query ProductCategories($limit: Int, $nextToken: String) {
        productCategories(limit: $limit, nextToken: $nextToken) {
            nextToken
            items {
                key
            }
        }
    }
`);
